module.exports = __webpack_public_path__ + "img/Trash.ed36095b.svg";